import React, { Component } from 'react';
import * as $ from 'jquery';
import ProsaPayment from './ProsaPayment.js';
import SuccessDialog from './SuccessDialog.js';
import Summary from './Summary.js';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import loadProsaCheckout from './loadProsaCheckout.js';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import AmexPaymentComponent from './AmexPaymentComponent.js';
import brandLogo from '../../../images/brand-logo-inverse-light.png';

export const CARD_TYPE = {
  VISA_MC: 1,
  AMEX: 2
}
let totalCargoTarjeta;
let cancelToken;
class ProsaPaymentContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();

  }

  componentWillMount = () => {

    cancelToken = axios.CancelToken.source();
    var invoice = JSON.parse(this.props.location.state.invoice);
    var get_data_invoices = JSON.parse(this.props.location.state.get_data_invoices);
    // Calculo de pago en factura se deja como tope 190000 para evitar conflictos con Conekta que tiene como maximo permitido 200,000 por transaccion
    //let totalPesos = (invoice.balance_mxn && invoice.balance_mxn <= 190000) ? invoice.balance_mxn : 190000.00;
    let totalPesos = 0
    get_data_invoices.map((invoice, index) => {
      if (invoice.status === 1) {
        totalPesos += Number(invoice.balance_mxn)
      }
    })

    /*//Se calcula comision de conekta para generer el cargo (Conekta utiliza el 2.9% de interes pero internamete se deja fijo a 3.01% para tener ganacia cambiaria)
    let comision = Number((((3.01) / 100) * totalPesos) + (2.5)).toFixed(2)
    let ivaComision = Number(comision * .16).toFixed(2)
    let comisionTotal = Number(parseFloat(comision) + parseFloat(ivaComision)).toFixed(2)*/

    //Se calcula comision de conekta para generer el cargo. Conekta utiliza el 3.4% + 3 + IVA de interes. Internamete se agrega 0.01 para tener ganacia cambiaria)
    const conekta_porcentaje_comision = (+process.env.REACT_APP_CONEKTA_PERCENTAGE_FEE / 100);
    const conekta_añadido_comision = +process.env.REACT_APP_CONEKTA_FIXED_FEE;
    const conekta_iva = +process.env.REACT_APP_CONEKTA_IVA;
    const ganancia_cambiaria = 0.01;
    let comisionTotal = (((totalPesos * conekta_porcentaje_comision) + conekta_añadido_comision) * (1 + conekta_iva) + ganancia_cambiaria) / (1 - (conekta_porcentaje_comision * (1 + conekta_iva)));
    comisionTotal = +(Math.round(comisionTotal + "e+2") + "e-2"); //Redondeamos a 2 decimales

    totalCargoTarjeta = +(Math.round((totalPesos + comisionTotal) + "e+2") + "e-2");

    this.setState({
      get_data_invoices: get_data_invoices,
      iid: invoice.id,
      ifolio: invoice.folio,
      amount: totalPesos,
      c_key: invoice.prosa_data.c_key,
      totalConekta: totalCargoTarjeta,
      comisionConekta: comisionTotal,
      abonoFactura: totalPesos
    });

    var dateFormat = moment().tz("America/Matamoros").format("YYYYMMDDHHmmss");
    var params = {
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      prosaEntityId: invoice.prosa_data.entity_id,
      prosaAmount: invoice.total_prosa * 1,
      prosaPaymentType: 'DB',
      prosaCurrency: "MXN",
      prosaMerchantTransactionId: invoice.folio + '_' + dateFormat,
      iid: invoice.id//383452 //invoice.id
    };

    localStorage.setItem('EID', invoice.prosa_data.entity_id);
    localStorage.setItem("invId", invoice.id);

    /*this.props.post(
      "/getProsaCheckout",
      params,
      (response) => this.callProsaCheckout(response),
      (error) => {this.props.handleErrorResponse(error);},cancelToken);*/

  }

  callProsaCheckout = (response) => {
    var json_response = JSON.parse(response);
    var checkoutId = json_response.id;
    var code = 'C' + json_response.result.code.replace(/\./g, '');
    var message = json_response.result.description;

    if (code == "C000200100") {
      loadProsaCheckout(() => {
        this.setState({ prosaCheckoutReady: true });
      }, checkoutId);
    } else {
      alert('Error al generar checkout');
    }

  }

  componentDidMount() {
    window.Conekta.setPublicKey(this.state.c_key);
    this.setModalListener();
    //quitar la clase 'container-fluid':  hace que el Summary se vea muy amontonado cuando se ve desde una sesion.
    $("div").removeClass("container-fluid");
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  didPayInvoice = () => {
    $('#btnfinish').click();
  }

  getInitState = () => {
    return ({
      amount: "",
      cardCvc: "",
      cardMonth: "",
      cardName: "",
      cardNumber: "",
      cardType: "",
      cardYear: "",
      city: "",
      country: "",
      isPaying: false,
      neighborhood: "",
      po: "",
      state: "",
      street: "",
      toInvoices: false,
      prosaCheckoutReady: false,
      checkoutId: '',
      invoice: "",
      paymentType: "1",
      paymentDetails: null,
      user: this.props.user,
      iid: "",
      ifolio: "",
      amount: 0,
      c_key: "",
      messageText: '',
      totalConekta: '',
      descuentoConekta: 2.9,
      comisionConekta: '',
      abonoFactura: '',
      typeInput: 'hidden',
      get_data_invoices: [],
    });
  }

  handleInputChange = (event) => {
    // Validar campo numerico
    if (event.target.value.length > 0 && event.target.value > 0) {
      // Se pone limite de $190,000 establecido por conekta
      if (event.target.value <= 190000) {
        // Se agrega validacion para no aceptar pagos mayores al valor de la factura
        if (event.target.value < (parseInt(totalCargoTarjeta) + parseInt(1))) {

          // Calculo de comicion conekta (Cuando es manual se respeta el 3.4% + 3MXN + IVA de comsion establecido por conekta)
          let comision = Number((((+process.env.REACT_APP_CONEKTA_PERCENTAGE_FEE) / 100) * parseFloat(event.target.value)) + (+process.env.REACT_APP_CONEKTA_FIXED_FEE)).toFixed(2)
          let ivaComision = Number(comision * +process.env.REACT_APP_CONEKTA_IVA).toFixed(2)
          let comisionTotal = Number(parseFloat(comision) + parseFloat(ivaComision)).toFixed(2)
          let ingresoFactura = Number(parseFloat(event.target.value) - parseFloat(comisionTotal)).toFixed(2)

          this.setState({ messageText: '', totalConekta: event.target.value, comisionConekta: comisionTotal, abonoFactura: ingresoFactura, typeInput: 'text' })
        } else {
          this.setState({ messageText: 'El monto a pagar no puede ser mayor al de la factura + comision $' + totalCargoTarjeta + '.', comisionConekta: 0, abonoFactura: 0, typeInput: 'hidden' })
        }
      } else {
        this.setState({ messageText: 'El monto máximo es de $190,000 MXN por transacción.', comisionConekta: 0, abonoFactura: 0, typeInput: 'hidden' })
      }
    } else {
      this.setState({ messageText: 'Solo se permiten caracteres numéricos.', comisionConekta: 0, abonoFactura: 0, typeInput: 'hidden' })
    }
  }

  //CONEKTA
  getTokenParams = () => {
    return {
      "card": {
        "number": this.state.cardNumber.trim(),
        "name": this.state.cardName.trim(),
        "exp_year": "20" + this.state.cardYear.trim(),
        "exp_month": this.state.cardMonth.trim(),
        "cvc": this.state.cardCvc.trim(),
        "address": {
          "street1": this.state.street.trim(),
          "street2": this.state.neighborhood.trim(),
          "city": this.state.city.trim(),
          "state": this.state.state.trim(),
          "zip": this.state.po.trim(),
          "country": this.state.country.trim()
        }
      }
    }
  }

  handleCardCvc = (event) => {
    this.setState({ cardCvc: event.target.value });
  }

  handleCardMonth = (event) => {
    this.setState({ cardMonth: event.target.value });
  }

  handleCardName = (event) => {
    this.setState({ cardName: event.target.value });
  }

  handleCardNumber = (event) => {
    this.setState({ cardNumber: event.target.value });
  }

  handleCardYear = (event) => {
    this.setState({ cardYear: event.target.value });
  }

  handleCityChange = (event) => {
    this.setState({ city: event.target.value });
  }

  handleClearError = () => {
    this.setState({ error: "" });
  }

  handleClearPromocode = () => {
    this.setState({ promocodeError: "" });
  }

  handleCountryChange = (event) => {
    this.setState({ country: event.target.value });
  }

  handleEmailChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { email: event.target.value }
      )
    });
  }

  handleLastnameChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { lastname: event.target.value }
      )
    });
  }

  handleNameChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { name: event.target.value }
      )
    });
  }

  handleNeighborhoodChange = (event) => {
    this.setState({ neighborhood: event.target.value });
  }

  registerPayment = (params) => {
    // Web service de pago
    this.props.post(
      "/payInvoiceAmex",
      params,
      (response, msg) => this.didPayInvoice(response, msg),
      (codigo, errortype, conekta, msg) => {
        this.paymentError(codigo, errortype, conekta, msg);
      },
      cancelToken);

  }

  paymentError = (codigo, errortype, conekta, msg) => {
    this.setState({ isPaying: false });
    alert(msg);
  }

  handlePaymentConekta = (params) => {

    const conektaParams = this.getTokenParams();
    const onSuccess = (token) => this.registerPayment(
      Object.assign({},
        params,
        { token_conekta: token.id })
    );

    const onError = (error) => {
      alert(error.message + "\n" + error.message_to_purchaser);
    }

    window.Conekta.Token.create(
      conektaParams,
      (token) => onSuccess(token),
      (error) => onError(error)
    );

  }

  handlePaymentSubmit = (event) => {
    event.preventDefault();

    const params = {
      get_data_invoices: this.state.get_data_invoices,
      email: this.state.user.email,
      name: this.state.user.name + " " + this.state.user.lastname,
      phone: this.state.user.phone,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      amount: this.state.amount,
      ifolio: this.state.ifolio,
      iid: this.state.iid,
      folio_externo: this.props.folio_externo,
      ingresoConekta: this.state.totalConekta,
      comisionConekta: this.state.comisionConekta,
      ingresoFactura: this.state.abonoFactura
    };
    localStorage.setItem("params", JSON.stringify(params));
    const callback = () => {
      this.handlePaymentConekta(params);
    };

    this.setState({ isPaying: true }, callback);
  }

  handlePhoneChange = (event) => {
    this.setState({
      user: Object.assign({},
        this.state.user,
        { phone: event.target.value }
      )
    });
  }

  handlePoChange = (event) => {
    this.setState({ po: event.target.value });
  }

  handleReservationTitle = (event) => {
    this.setState({ reservationTitle: event.target.value });
  }

  handleStateChange = (event) => {
    this.setState({ state: event.target.value });
  }

  handleStreetChange = (event) => {
    this.setState({ street: event.target.value });
  }
  //CONEKTA


  setModalListener = () => {
    $('#modalPaymentfinish').on('hidden.bs.modal', () => {
      this.setState({ toInvoices: true });
    });
  }

  renderPayment = () => {
    return (
      this.state.prosaCheckoutReady ? <ProsaPayment /> : 'Loading...'
    );
  }

  renderSuccessDialog = () => {
    return (
      <SuccessDialog />
    );
  }

  renderAMEX = () => {
    return (<AmexPaymentComponent
      cardMonth={this.state.cardMonth}
      cardName={this.state.cardName}
      cardNumber={this.state.cardNumber}
      cardCvc={this.state.cardCvc}
      cardYear={this.state.cardYear}
      city={this.state.city}
      country={this.state.country}
      error={this.state.error}
      handleCardCvc={this.handleCardCvc}
      handleCardMonth={this.handleCardMonth}
      handleCardName={this.handleCardName}
      handleCardNumber={this.handleCardNumber}
      handleCardYear={this.handleCardYear}
      handleCityChange={this.handleCityChange}
      handleClearError={this.handleClearError}
      handleCountryChange={this.handleCountryChange}
      handleEmailChange={this.handleEmailChange}
      handleLastnameChange={this.handleLastnameChange}
      handleNameChange={this.handleNameChange}
      handleNeighborhoodChange={this.handleNeighborhoodChange}
      handlePaymentSubmit={this.handlePaymentSubmit}
      handleReservationOccupancy={this.handleReservationOccupancy}
      handlePhoneChange={this.handlePhoneChange}
      handlePoChange={this.handlePoChange}
      handleReservationTitle={this.handleReservationTitle}
      handleStateChange={this.handleStateChange}
      handleStreetChange={this.handleStreetChange}
      isPaying={this.state.isPaying}
      neighborhood={this.state.neighborhood}
      po={this.state.po}
      state={this.state.state}
      street={this.state.street}
      user={this.state.user}
      folio_externo={this.props.folio_externo} />
    );
  }

  renderSummary = () => {
    return (
      <Summary
        invoice={JSON.parse(this.props.location.state.invoice)}
        get_data_invoices={JSON.parse(this.props.location.state.get_data_invoices)}
        handleInputChange={this.handleInputChange}
        messageText={this.state.messageText}
        descuentoConekta={this.state.descuentoConekta}
        ingresoPago={this.state.totalConekta}
        comisionPago={this.state.comisionConekta}
        totalPago={this.state.abonoFactura}
        typeInput={this.state.typeInput} />
    );
  }

  renderPago = () => {
    return (
      <div>
        <div>
          <button
            className="hidden"
            data-target="#modalPaymentfinish"
            data-toggle="modal"
            id="btnfinish"
            type="button">
          </button>
          <div className="modal fade" id="modalPaymentfinish" role="dialog" style={{ textAlign: "left" }}>
            <div className="modal-dialog Payment">
              <div className="modal-content">
                <div className="modal-header Payment" style={{ background: "#3CC" }}>
                  <button id="modal_colosepayment_finish" type="button" className="close btn-primary" data-dismiss="modal" aria-label="Close "><span aria-hidden="true" style={{ fontSize: '30px', background: 'red', width: '30px', display: 'block' }}>&times;</span></button>
                  <div className="navbar-header">
                    <div className="navbar-brand" style={{ display: 'flex' }}>
                      <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
                    </div>
                  </div>
                </div>
                <p style={{ color: "3CCC", padding: "10px", fontSize: "20px" }}>
                  Pago Completado 2
                  <br></br>
                  Se enviará un correo de confirmación
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    )
  }

  handlePaymentChange = (event) => {

    if (event.target.value  === "1") {
      $('#collapseOne').addClass("in");
      $('#collapseTwo').removeClass("in");
    } else {
      $('#collapseTwo').addClass("in");
      $('#collapseOne').removeClass("in");
    }


    this.setState({ paymentType: event.target.value });
  }



  render() {
    if (this.state.toInvoices) {
      return <Redirect to={{
        pathname: "/",
      }} />;
    }

    const { t } = this.props;
    const url = this.props.folio_externo ? "/payment/"+this.props.folio_externo : null;
    return (
      <div className="container_invoice_externa_container">
        <h2 className="page-header">{t('dashboard.invoice_payment.heading')}</h2>
        {this.renderSummary()}
        <div className="panel-group" id="accordion">
          {this.renderAMEX()}
        </div>
        {this.renderSuccessDialog()}
        <div>
          {!this.props.folio_externo ? (
            <Link to="/invoices">
              <i className="fa fa-fw fa-arrow-left" />&nbsp;
              {t('dashboard.btn_back')}
            </Link>
          ):(
            <Link to={url} >
              <i className="fa fa-fw fa-arrow-left" />&nbsp;
              {t('dashboard.btn_back')}
            </Link>
          )}
        </div>
        {this.renderPago()}
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(ProsaPaymentContainer);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/payment/ProsaPaymentContainer.js